import { render, staticRenderFns } from "./DisparosOld.vue?vue&type=template&id=49418584"
import script from "./DisparosOld.vue?vue&type=script&lang=js"
export * from "./DisparosOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports